
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Box, Flex, Heading, Text, Link as ChakraLink } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { NextSeo } from "next-seo";
import { BlogPostsMainData, BreadcrumbType } from "@/Types/types";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { GetServerSideProps } from "next";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import VerticalCardImg from "@/components/VerticalCardImg";
import HeaderMenu from "@/components/HeaderMenu";
import Footer from "@/components/Footer";
import { handleError } from "@/helpers/handleError";
import { notFoundSemCache } from "@/helpers/notFoundSemCache";
import { configFile } from "@/config";
import Breadcrumbs from "@/components/Breadcrumbs";
import { breadcrumbInitial } from "@/data/breadcrumbInitial";
import { GET_HEADER_DATA } from "@/graphql/headerQueries";
import Link from "next/link";
import { GET_TAG, GET_TAG_POSTS } from "@/graphql/tagQueries";
import { ONE_DAY_IN_SECONDS, ONE_MINUTE_IN_SECONDS } from "@/constants/timeConstants";
export default function PostPage(props: any) {
    const [pageUrl, setPageUrl] = useState<string>();
    const [page, setPage] = useState<number>();
    const [counter, setCounter] = useState<number>();
    const [pageCount, setPageCount] = useState<number>();
    const [prevHref, setPrevHref] = useState<string>();
    const [isPrevDisabled, setIsPrevDisabled] = useState<boolean>();
    const [isNextDisabled, setIsNextDisabled] = useState<boolean>();
    const [isPagination, setIsPagination] = useState<boolean>();
    const router = useRouter();
    useEffect(() => {
        setIsPrevDisabled(page === 1);
        props &&
            setIsNextDisabled(page === props.tagPosts.meta.pagination.pageCount);
        if (pageUrl !== undefined) {
            if (page !== 1) {
                router.push({
                    pathname: router.route,
                    query: {
                        pageUrl,
                        page
                    }
                }, `/tag/${pageUrl}?page=${page}`, { shallow: false });
            }
            if (page === 1 && +(router.query.page as string) === 2) {
                router.push({
                    pathname: router.route,
                    query: {
                        pageUrl
                    }
                }, `/tag/${pageUrl}`, { shallow: false });
            }
        }
    }, [page]);
    const handleClick = useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
        if (page === 2) {
            setPrevHref(`/tag/${props.tag.data[0].attributes.url}`);
        }
        else if (page === 1) {
            setPrevHref("");
        }
        else {
            setPrevHref(`?page=${page! - 1}`);
        }
    }, [page]);
    useEffect(() => {
        setPageUrl(props.tag.data[0].attributes.url);
        setCounter(props.tagPosts.meta.pagination.total);
        setPageCount(props.tagPosts.meta.pagination.pageCount);
        setIsPagination(props.tagPosts.meta.pagination.pageCount > 1);
        if (router.isReady) {
            setPage(+(router.query.page as unknown as number) || 1);
        }
    }, []);
    return (<>
      <HeaderMenu cookies={props.cookies.data} menu={props.navbar.data?.attributes.header_links}/>
      <NextSeo title={props.tag.data[0].attributes.seo.metaTitle} description={props.tag.data[0].attributes.seo.metaDescription} canonical={props.tag.data[0].attributes.seo.canonicalURL}/>
      <Box maxWidth="1216px" margin="0 auto" width="90%" mb="32px" as="header" pt={{ base: "60px", lg: "32px" }}>
        <Breadcrumbs data={props.breadcrumbs}/>
        <Heading mb="32px" as="h1" fontWeight="800" position="relative">
          {props.tag.data[0].attributes.tag}
          <Text as="span" bgColor={configFile.primaryAccentColor} height="20px" color="#fff" display="inline-flex" fontWeight="700" fontSize="12px" lineHeight="16px" justifyContent="center" alignItems="center" position="relative" ml="20px" top="-5px" padding="0 5px">
            {counter}
          </Text>
        </Heading>
        <Text color="gray.600" fontSize="20px" lineHeight="28px">
          {props.tag.data[0].attributes.description}
        </Text>
      </Box>
      <Flex maxWidth="1216px" margin="0 auto" width="90%" columnGap="32px" rowGap="32px" flexWrap="wrap" pb={{ base: "44px", lg: "64px" }} justifyContent="flex-start">
        {props.tagPosts.data.map((item: BlogPostsMainData, index: number) => (<VerticalCardImg notMainPage key={index} item={item}/>))}
      </Flex>
      {isPagination && (<Flex padding="12px" bgColor="#fff" columnGap={{ base: "16px", md: "32px" }} border="1px solid #E2E8F0" borderRadius="6px" alignItems="center" width="fit-content" margin="0 auto" mb="80px">
          <ChakraLink prefetch={false} as={Link} href={prevHref} className={isPrevDisabled ? "disabled" : ""} onClick={(e) => [
                e.preventDefault(),
                setPage(page! - 1),
                handleClick,
            ]} width={{ base: "90px", md: "150px" }} display="flex" alignItems="center" bgColor={configFile.primaryAccentColor} height="40px" justifyContent="center" borderRadius="6px" lineHeight="1" fontWeight="600" fontSize={{ base: "13px", md: "16px" }} color="#fff" border="1px solid transparent" _hover={{
                color: "gray.800",
                bgColor: "#fff",
                borderColor: "#E2E8F0"
            }} _disabled={{ bgColor: "#fff", borderColor: "#E2E8F0" }}>
            <ChevronLeftIcon />
            Previous
          </ChakraLink>
          <Text fontSize={{ base: "13px", md: "16px" }} color="gray.500" fontWeight="400">
            Page {page} of {pageCount}
          </Text>
          <ChakraLink prefetch={false} as={Link} href={isNextDisabled ? "" : `?page=${page! + 1}`} className={isNextDisabled ? "disabled" : ""} onClick={(e) => [
                e.preventDefault(),
                setPage(page! + 1),
                handleClick,
            ]} width={{ base: "90px", md: "150px" }} display="flex" justifyContent="center" borderRadius="6px" height="40px" alignItems="center" bgColor={configFile.primaryAccentColor} lineHeight="1" fontWeight="600" fontSize={{ base: "13px", md: "16px" }} border="1px solid transparent" color="#fff" _hover={{
                color: "gray.800",
                bgColor: "#fff",
                borderColor: "#E2E8F0"
            }} _disabled={{
                color: "gray.800",
                bgColor: "#fff",
                borderColor: "#E2E8F0"
            }}>
            Next <ChevronRightIcon />
          </ChakraLink>
        </Flex>)}
      <Footer menu={props.footer[0].items}/>
    </>);
}
const getServerSideProps: GetServerSideProps = async (context) => {
    try {
        context.res.setHeader("Cache-Control", `public, s-maxage=${ONE_DAY_IN_SECONDS}, immutable`);
        const client = new ApolloClient({
            uri: `${process.env.NEXT_PUBLIC_API_URL}/graphql`,
            cache: new InMemoryCache()
        });
        const { data: headerData } = await client.query({
            query: GET_HEADER_DATA
        });
        const { data: tagData } = await client.query({
            query: GET_TAG,
            variables: { slugUrl: context.params?.slug }
        });
        if (!tagData.tag.data.length) {
            return notFoundSemCache(context.res);
        }
        const { data: tagPosts } = await client.query({
            query: GET_TAG_POSTS,
            variables: {
                tag: tagData.tag.data[0].attributes.url,
                page: (context.query?.page && +context.query?.page) || 1
            }
        });
        const breadcrumbs: BreadcrumbType[] = JSON.parse(JSON.stringify(breadcrumbInitial));
        breadcrumbs.push({
            href: `/tag/${tagData.tag.data[0].attributes.url}`,
            label: tagData.tag.data[0].attributes.seo.metaTitle
        });
        return {
            props: { ...tagData, ...tagPosts, ...headerData, breadcrumbs }
        };
    }
    catch (error) {
        handleError(error, "Tag Slug getServerSideProps");
        return notFoundSemCache(context.res);
    }
};

    async function __Next_Translate__getServerSideProps__1a1756cef0f__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/tag/[slug]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1756cef0f__ as getServerSideProps }
  